var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInformation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M140 20c66.274 0 120 53.726 120 120s-53.726 120-120 120S20 206.274 20 140 73.726 20 140 20m10 110h-30c-5.523 0-10 4.477-10 10s4.477 10 10 10v40c-5.523 0-10 4.477-10 10s4.477 10 10 10h40c5.523 0 10-4.477 10-10s-4.477-10-10-10v-50c0-5.523-4.477-10-10-10m-10-60c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20"
})));
export default SvgInformation;